import { render } from "./DiagnosisCheckCable.vue?vue&type=template&id=505ad80d"
import script from "./DiagnosisCheckCable.vue?vue&type=script&lang=js"
export * from "./DiagnosisCheckCable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__